import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';

const CompanionsFooterCta: React.FC = () => (
  <section className="relative mx-auto max-w-7xl px-4 pb-16 pt-4 sm:px-8 sm:pb-20">
    <div className="relative overflow-hidden rounded-[var(--cp-radius-xl)] bg-gradient-to-l from-[var(--cp-brand)] via-[#2d4ab8] to-[var(--cp-accent)] p-6 text-white shadow-[0_32px_64px_-40px_rgba(28,59,155,0.55)] sm:p-10">
      <div className="pointer-events-none absolute -left-20 -top-20 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-16 -right-10 h-48 w-48 rounded-full bg-[var(--cp-violet)]/30 blur-3xl" />
      <div className="relative flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-xl text-right">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-black">
            <Compass className="h-3.5 w-3.5" />
            گام بعدی مسیر
          </span>
          <h2 className="mt-4 text-2xl font-black leading-tight sm:text-3xl">
            آماده‌اید همراه جدید جامعه من حقیقی شوید؟
          </h2>
          <p className="mt-3 text-sm leading-7 text-white/80 sm:text-base">
            دوره‌ها و تمرین‌های ما مسیر رشد شخصی را با پشتیبانی جامعه جهانی همراهان همراه می‌کنند.
          </p>
        </div>
        <Link
          to="/courses"
          className="inline-flex shrink-0 items-center justify-center gap-2 self-start rounded-2xl bg-white px-6 py-3.5 text-sm font-black text-[var(--cp-brand)] shadow-lg transition hover:scale-[1.02] hover:bg-slate-50 sm:self-center"
        >
          مشاهده دوره‌ها
          <ArrowLeft className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default CompanionsFooterCta;
